import { useCallback, useEffect, useRef, useState } from "react";
import { Kunden } from "./kunden";
import { House, ChevronRight, FileText, ScrollText, User } from "lucide-react";
import { PlotHusmodell } from "./plotHusmodell";
import { ProjectAccounting } from "./projectAccounting";
import { Oppsummering } from "./oppsummering";
import { Link, useLocation } from "react-router-dom";
import { fetchAdminData, fetchBankLeadData } from "../../../api";
// import { Forhandstakst } from "./forhandstakst";

export const BankleadsTabs = () => {
  const [activeTab, setActiveTab] = useState<any>(0);
  const tabData = [
    {
      label: "Kundeopplysninger",
      icon: <User className="w-4 h-4 md:w-6 md:h-6" />,
    },
    {
      label: "Tomt og husmodell",
      icon: <House className="w-4 h-4 md:w-6 md:h-6" />,
    },
    {
      label: "Økonomisk plan",
      icon: <ScrollText className="w-4 h-4 md:w-6 md:h-6" />,
    },
    // {
    //   label: "Forhåndstakst",
    //   icon: <FileText className="w-4 h-4 md:w-6 md:h-6" />,
    // },
    {
      label: "Oppsummering",
      icon: <FileText className="w-4 h-4 md:w-6 md:h-6" />,
    },
  ];
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const id = pathSegments.length > 2 ? pathSegments[2] : null;
  const [bankData, setBankData] = useState<any>();

  const getData = useCallback(async () => {
    if (!id) return;

    try {
      const data = await fetchBankLeadData(id);
      if (data) {
        setBankData(data);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  }, [id]);
  useEffect(() => {
    if (!id) {
      return;
    }

    getData();
  }, [getData]);
  // const plotData = bankData?.plotHusmodell?.plot;
  // const houseData = bankData?.plotHusmodell?.house;

  const kundenRef = useRef<any>(null);
  const plotHusmodellRef = useRef<any>(null);
  const projectAccountingRef = useRef<any>(null);
  const ForhandstakstRef = useRef<any>(null);
  const FremdriftsplanRef = useRef<any>(null);

  const validateBeforeTabChange = async (targetTabIndex: number) => {
    if (activeTab === 0 && kundenRef.current) {
      const isValid = await kundenRef.current.validateForm();
      if (!isValid) return;
    }
    if (activeTab === 1 && plotHusmodellRef.current) {
      const isValid = await plotHusmodellRef.current.validateForm();
      if (!isValid) return;
    }
    if (activeTab === 2 && projectAccountingRef.current) {
      const isValid = await projectAccountingRef.current.validateForm();
      if (!isValid) return;
    }
    if (activeTab === 3 && ForhandstakstRef.current) {
      const isValid = await ForhandstakstRef.current.validateForm();
      if (!isValid) return;
    }
    if (activeTab === 4 && FremdriftsplanRef.current) {
      const isValid = await FremdriftsplanRef.current.validateForm();
      if (!isValid) return;
    }

    setActiveTab(targetTabIndex);
  };

  // function norwegianToNumber(str: any) {
  //   if (typeof str !== "string") return 0;
  //   return Number(str.replace(/\s/g, ""));
  // }

  // const sum =
  //   norwegianToNumber(plotData?.tomtekostnader) +
  //   norwegianToNumber(houseData?.byggekostnader);

  // function numberToNorwegian(num: any) {
  //   return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  // }

  const [assignUser, setAssignUser] = useState<any>(null);

  useEffect(() => {
    const getData = async () => {
      const data: any = await fetchAdminData(bankData?.assignedTo);
      if (data) {
        setAssignUser(data);
      }
    };
    if (bankData && bankData?.assignedTo) {
      getData();
    }
  }, [bankData]);

  const tabRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = tabRef.current;
    if (!container) return;

    const activeButton = container.querySelectorAll("button")[activeTab];
    if (activeButton) {
      const containerRect = container.getBoundingClientRect();
      const buttonRect = activeButton.getBoundingClientRect();
      const scrollLeft =
        activeButton.offsetLeft -
        containerRect.width / 2 +
        buttonRect.width / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }
  }, [activeTab]);

  return (
    <>
      <div className="p-2 pt-0">
        <div className="border border-gray3 rounded-lg">
          <div className="p-4 flex flex-col gap-2 border-b border-gray3">
            <div className="flex items-center gap-1 flex-wrap">
              <Link
                to={"/bank-leads"}
                className="text-gray4 text-xs md:text-sm cursor-pointer"
              >
                Bank Leads
              </Link>
              <ChevronRight className="h-4 w-4 text-gray5" />
              <span className="text-black3 text-sm md:text-base lg:text-lg font-bold">
                Registrer lead til bank
              </span>
            </div>
            <p className="text-gray4 text-xs md:text-sm">
              Her registrer du informasjon om kunden. Jo mer informasjon, jo
              bedre kan banken forberede seg for de tar kontakt med kunden.
            </p>
            {assignUser && (
              <div>
                <span className="text-darkBlack text-sm md:text-base desktop:text-lg font-medium">
                  Bank Agent: {assignUser?.f_name ?? assignUser?.name}{" "}
                  {assignUser?.l_name ?? ""}
                </span>{" "}
                <span className="text-gray4 text-xs md:text-sm lg:text-base">
                  ({assignUser?.email})
                </span>
              </div>
            )}
          </div>
          <div className="relative flex flex-col lg:flex-row items-start gap-6 px-3 lg:px-4 py-4 lg:py-5">
            <div
              ref={tabRef}
              className="overflow-x-auto w-full lg:w-auto HideScrollbar"
            >
              <div className="flex lg:flex-col gap-2 bg-white">
                {tabData.map((tab, index) => (
                  <button
                    key={index}
                    className={`text-sm whitespace-nowrap relative ${
                      id ? "cursor-pointer" : "cursor-auto"
                    } flex items-center gap-2 text-darkBlack py-2 px-2 md:px-3 rounded-lg ${
                      activeTab === index
                        ? "font-semibold bg-darkGreen2 text-primary"
                        : "text-gray5"
                    }`}
                    onClick={() => {
                      if (id) {
                        validateBeforeTabChange(index);
                      }
                    }}
                    style={{
                      boxShadow:
                        activeTab === index ? "0px 1px 2px 0px #1018281A" : "",
                    }}
                  >
                    {activeTab === index && (
                      <div
                        className="absolute left-1 border-l-2 border-green3 h-5"
                        style={{
                          boxShadow: "3px 0 24px 4px rgba(0, 136, 70, 0.6)",
                          backdropFilter: "blur(8px)",
                          borderRadius: "2px",
                        }}
                      ></div>
                    )}
                    <span
                      className={`${activeTab === index ? "text-white" : ""}`}
                    >
                      {tab.icon}
                    </span>
                    <span
                      className={`${
                        activeTab === index ? "text-white" : "text-gray4"
                      }`}
                    >
                      {tab.label}
                    </span>
                  </button>
                ))}
              </div>
            </div>

            <div className="flex-1 w-full">
              {activeTab === 0 && (
                <Kunden ref={kundenRef} setActiveTab={setActiveTab} />
              )}
              {activeTab === 1 && (
                <PlotHusmodell
                  ref={plotHusmodellRef}
                  setActiveTab={setActiveTab}
                />
              )}
              {activeTab === 2 && (
                <ProjectAccounting
                  ref={projectAccountingRef}
                  setActiveTab={setActiveTab}
                  getData={getData}
                />
              )}
              {/* {activeTab === 3 && (
                <Forhandstakst
                  setActiveTab={setActiveTab}
                  ref={ForhandstakstRef}
                />
              )} */}
              {activeTab === 3 && <Oppsummering setActiveTab={setActiveTab} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
